export enum CardVariation {
  MINI = 1,
  TOOLBAR = 2
}

export enum CounterType {
  USERS = 1,
  GAMES = 2
}